import { isDropdownOption } from "../option/index.js";
/**
 * Predicate function that determines if the element should be considered an option group.
 * Uses duck-typing by checking for the presence of an `options` array property
 * rather than relying on the tag name, making it prefix-agnostic.
 *
 * @param element - The element to check.
 * @returns true if the element is an option group.
 * @public
 */
export function isOptionGroup(element) {
    if ((element === null || element === void 0 ? void 0 : element.nodeType) !== Node.ELEMENT_NODE) {
        return false;
    }
    if ("options" in element) {
        return Array.isArray(element.options);
    }
    return false;
}
/**
 * Gets the dropdown options from an element, handling both direct options and option groups.
 *
 * @param element - The element to extract options from.
 * @returns An array of DropdownOption elements.
 * @public
 */
export function getOptionsFromElement(element) {
    if (isOptionGroup(element)) {
        return element.options;
    }
    if (isDropdownOption(element)) {
        return [element];
    }
    return [];
}
//# sourceMappingURL=option-group.options.js.map